import { useState } from 'react'
import { useIntl } from 'react-intl'
import { Button } from 'react-md'
import { useDispatch } from 'react-redux'
import { _confirmPurchaseInvoice } from 'state/finance-viilutalous-actions'
import LoadingState from 'ui/components/LoadingState'
import * as notifyActions from 'state/notifyActions'

type ConfirmButtonProps = {
	purchaseInvoiceId: number | undefined
	databaseSource: string | undefined
	companyUUID: string | undefined
	refresh: () => void
}
const ConfirmButton = ({
	purchaseInvoiceId,
	databaseSource,
	companyUUID,
	refresh,
}: ConfirmButtonProps) => {
	const intl = useIntl()
	const dispatch = useDispatch()
	const [processing, setProcessing] = useState(false)

	const canSubmit =
		!processing &&
		!!databaseSource &&
		!!companyUUID &&
		purchaseInvoiceId !== undefined

	const handleApprove = async () => {
		setProcessing(true)
		try {
			const result = await _confirmPurchaseInvoice({
				companyUUID: companyUUID!,
				databaseSource: databaseSource!,
				purchaseInvoiceId: purchaseInvoiceId!,
			})
			if (!result?.ok) {
				console.error('Confirm response not ok:', result)
				throw new Error('Confirm response not ok')
			}
			const res = await result.json()
			if (res.success === false) {
				console.error('Error confirming purchase invoice:', res)
				throw new Error('Error confirming purchase invoice')
			}
			dispatch(
				notifyActions.success(
					intl.formatMessage({
						defaultMessage: 'Lasku hyväksytty onnistuneesti.',
						description: 'Success message when purchase invoice is approved',
					}),
				),
			)
			refresh?.()
		} catch (error) {
			console.error('Error approving purchase invoice:', error)
			dispatch(
				notifyActions.error(
					intl.formatMessage({
						defaultMessage:
							'Laskun hyväksymisessä tapahtui virhe. Yritä myöhemmin uudelleen.',
						description: 'Error message when approving purchase invoice fails',
					}),
				),
			)
		} finally {
			setProcessing(false)
		}
	}

	return (
		<Button
			style={{ marginRight: '5px' }}
			raised
			secondary
			onClick={handleApprove}
			disabled={!canSubmit}
		>
			{processing ? (
				<LoadingState small />
			) : (
				intl.formatMessage({
					defaultMessage: 'Hyväksy',
					description: 'Label for the button.',
				})
			)}
		</Button>
	)
}

export default ConfirmButton
